import {theme} from "@/theme"
import * as am4core from "@amcharts/amcharts4/core"
import {mdiArrowUpBold, mdiArrowDownBold} from "@mdi/js"

const t = theme()

export function chartTheme(target: am4core.ColorSet): void {
  target.list = [
    am4core.color(t.primaryColor),
    am4core.color(t.secondaryColor),
    am4core.color(t.alt1Color),
    am4core.color(t.alt2Color),
    am4core.color(t.alt3Color),
    am4core.color(t.alt4Color),
    am4core.color(t.alt5Color),
    am4core.color(t.alt6Color),
  ]
}

export function getArrow(
  growth: number,
  isDownPositive: boolean
): {symbol: string; color: string} {
  return growth === 0
    ? {symbol: "", color: ""}
    : growth < 0
    ? {
        symbol: mdiArrowDownBold,
        color: isDownPositive ? t.positiveColor : t.negativeColor,
      }
    : {
        symbol: mdiArrowUpBold,
        color: isDownPositive ? t.negativeColor : t.positiveColor,
      }
}
